import React from 'react'

const Footer = () => {
  return (
    <div className='bg-active-black text-active-white flex items-center justify-center gap-8 flex-col md:flex-row py-5 z-10'>
        <p>Developed by Subashkumar.</p>
        <p>Copyright &copy; 2023 SK </p>
    </div>
  )
}

export default Footer